

import { css } from 'lit';

export default css`
  /* Sizes */
  --height-controls-tiny: 1.5rem;
  --height-controls-small: 2rem;
  --height-controls-medium: 2.5rem;
  --height-controls-large: 3rem;
  --height-controls-giant: 3.5rem;

  --height-button-tiny:  var(--height-controls-tiny);
  --height-button-small: var(--height-controls-small);
  --height-button-medium: var(--height-controls-medium);
  --height-button-large: var(--height-controls-large);
  --height-button-giant: var(--height-controls-giant);

  --height-select-tiny:  var(--height-controls-tiny);
  --height-select-small: var(--height-controls-small);
  --height-select-medium: var(--height-controls-medium);
  --height-select-large: var(--height-controls-large);
  --height-select-giant: var(--height-controls-giant);

  --height-input-tiny:  var(--height-controls-tiny);
  --height-input-small: var(--height-controls-small);
  --height-input-medium: var(--height-controls-medium);
  --height-input-large: var(--height-controls-large);
  --height-input-giant: var(--height-controls-giant);
`;
